<template>
  <div class="location-list-item">
    <base-list-item class="map-display-with-details">
      <base-list-item class="location-details" v-if="fetched && location">
        <p class="name" v-if="location.Name">{{ location.Name }}</p>
        <p class="name" v-if="location.name">{{ location.name }}</p>
        <p>{{ lineOne }}</p>
        <p>{{ lineTwo }}</p>
      </base-list-item>
      <base-list-item
        class="location-details skeleton"
        v-if="!fetched || !location"
      ></base-list-item>
      <div class="map-container" :id="containerId"></div>
    </base-list-item>
    <trash-button-expanding
      v-if="tenant && deletable"
      @delete="removeLocation"
    />
  </div>
</template>

<script>
import BaseListItem from "../BaseListItem.vue";
import TrashButtonExpanding from "../TrashButtonExpanding.vue";
export default {
  data() {
    return {
      mapInstance: undefined,
      client: null,
      credentials: undefined,
    };
  },
  computed: {
    tenant() {
      return true;
    },
    containerId() {
      return `${this.location ? this.location.userId : Date.now()}-map-display`;
    },
    lineOne() {
      let string = "";
      switch (this.location.api_version) {
        case "9-28-2022":
          if (this.location.AddressNumber) {
            string = string + this.location.AddressNumber;
          }
          if (this.location.Street) {
            string = string + ` ${this.location.Street}`;
          }
          break;
        default:
          if (this.location.address) {
            if (this.location.address.streetAddress1) {
              string = this.location.address.streetAddress1;
            }
            if (this.location.address.streetAddress2) {
              string = string + ` ${this.location.address.streetAddress2}`;
            }
          }
          break;
      }
      return string;
    },
    lineTwo() {
      let string = "";
      switch (this.location.api_version) {
        case "9-28-2022":
          if (this.location.Municipality) {
            string = string + this.location.Municipality;
          }
          if (this.location.Region) {
            string = string + `, ${this.location.Region}`;
          }
          if (this.location.PostalCode) {
            string = string + `, ${this.location.PostalCode}`;
          }
          break;
        default:
          if (this.location.address) {
            string = this.location.address.cityStateZip;
          }
          break;
      }
      return string;
    },
  },
  methods: {
    removeLocation() {
      this.$emit("remove-location");
    },
  },
  components: {
    BaseListItem,
    TrashButtonExpanding,
  },
  props: {
    location: {
      type: Object,
    },
    fetched: {
      type: Boolean,
    },
    deletable: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
};
</script>
<style scoped>
.location-list-item {
  display: flex;
  justify-content: stretch;
  height: 120px;
  width: 100%;
  margin-bottom: 10px;
  z-index: 1;
}
.map-display-with-details {
  height: 100%;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: right;
  align-items: flex-start;
  box-sizing: border-box;
  position: relative;
}
.map-container {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.location-details {
  z-index: 2;
  height: fit-content;
  width: fit-content;
  margin: auto 20px;
}

.skeleton {
  height: 50px;
  width: 150px;
  background-color: var(--secondaryColor);
}

p {
  margin: 0;
  font-family: Raleway;
  font-weight: 500;
  font-size: 0.7em;
  text-align: left;
}

.name {
  font-weight: 600;
}
</style>
